import Transition from './Transition'

export default class EmptyTransition extends Transition {
  constructor(transitionParams) {
    super(transitionParams)
    this._isInTransitionPerformed = true
    this._isOutTransitionPerformed = true
  }
}
